import { listService } from '../../services/service-factory';

export default {
  data: function() {
    return {
      listService: undefined
    };
  },
  created: function() {
    this.listService = listService;
  }
};
